import InternalLayout, { Content, Footer, Header } from './layout';
import Sider from './Sider';
var Layout = InternalLayout;
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = Content;
Layout.Sider = Sider;
export default Layout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-components-antd-x4/es/layout/index.js
// module id = 1998
// module chunks = 0